export const hasCredits = userDetails => {
    if (!userDetails?.credits) return false;

    return (userDetails.credits.total - userDetails.credits.used) > 0;
}

export const hasActiveSubscription = (userDetails) => {
    return !!userDetails?.subscription?.active
}